import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { ResumeValidationStatus } from 'builder/modules/constants'
import { selectors } from 'builder/modules/resumeEditor'
import ModalOverlay from '../ModalOverlay'

import UploadResume from './UploadResume'
import { AutotaloringView } from './AutotaloringView'
import { OptionsViewV3 } from './OptionsViewV3'
type Props = {
  onClose: () => void
}

export const FillResumeModal = (props: Props) => {
  const { onClose } = props
  const { isPhone } = useMediaQueries()
  const { resumeValidationStatus } = useTypedSelector(
    state => state.resumeEditor.prefillResumeSection,
  )

  const resumeUploadingNotStarted = resumeValidationStatus === ResumeValidationStatus.notStarted

  const autoTailoringFromPublicJobBoard = useTypedSelector(
    selectors.autoTailoringFromPublicJobBoard,
  )

  return (
    <ModalOverlay
      onClick={onClose}
      overlayFadeDuration={150}
      contentSlideDuration={150}
      fullScreen={isPhone}
    >
      {autoTailoringFromPublicJobBoard.enabled ? (
        <AutotaloringView {...{ onClose }} />
      ) : resumeUploadingNotStarted ? (
        <OptionsViewV3 {...{ onClose }} />
      ) : (
        <UploadResume {...{ onClose }} />
      )}
    </ModalOverlay>
  )
}
